import { FC, HTMLAttributes } from 'react';

type StarKeyWalletProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const StarKeyWallet: FC<StarKeyWalletProps> = ({ size = 16, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 51 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.6912 0.895264C11.9301 0.895264 0.772217 12.1784 0.772217 26.0887C0.772217 36.1757 6.63365 44.869 15.0984 48.8953L19.3546 37.2704C15.5262 35.049 12.9439 30.8733 12.9439 26.0887C12.9439 18.9707 18.6522 13.2036 25.686 13.2036C32.7197 13.2036 38.428 18.976 38.428 26.0887C38.428 30.8733 35.8458 35.0437 32.0174 37.2704L36.2735 48.8953C44.7383 44.869 50.5997 36.1704 50.5997 26.0887C50.605 12.1784 39.4472 0.895264 25.6912 0.895264Z"
        fill="url(#paint0_linear_1463_870)"
      ></path>
      <path
        d="M35.4972 26.0887C28.9599 27.915 27.4971 29.3941 25.6912 36.0048C23.8852 29.3941 22.4225 27.915 15.8851 26.0887C22.4225 24.2625 23.8852 22.7833 25.6912 16.1726C27.4971 22.7833 28.9599 24.2625 35.4972 26.0887Z"
        fill="white"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1463_870"
          x1="0"
          y1="25.4765"
          x2="50.2406"
          y2="25.4765"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEBF4E"></stop>
          <stop offset="0.715" stopColor="#FC4CD2"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default StarKeyWallet;
